import i18n from '@app/translation/i18n';
import * as yup from 'yup';

export const getDeliveryWindowsSchema = () =>
  yup.array(yup.string().defined()).min(1, i18n.t('validation:provide_min_one_delivery_window_hint')).required();
